import React from 'react';
import { useCarrierOrg } from '../../hooks/useCarrierOrg';
import CarrierInvoiceProfileForm from './CarrierInvoiceProfileForm';
import { ui } from './carrierStyles';

export default function CarrierSettings() {
  const { loading, orgId, org, isAdmin } = useCarrierOrg();

  if (loading) return null;
  if (!isAdmin) return <p style={ui.hint}>Bare administratorer kan endre innstillingene.</p>;

  return (
    <>
      <h1 style={ui.h1}>Innstillinger</h1>
      <div style={ui.card}>
        <h2 style={ui.h2}>Firma</h2>
        <p style={{ margin: 0 }}><strong>{org.orgName}</strong></p>
        <p style={ui.hint}>Organisasjonsnummer {org.orgNumber}</p>
      </div>

      <div style={ui.card}>
        <h2 style={ui.h2}>Fakturaopplysninger</h2>
        <p style={ui.hint}>Brukes som utsender når firmaet fakturerer kunder. Bare administratorer ser kontonummeret.</p>
        <CarrierInvoiceProfileForm orgId={orgId} defaults={{ legalName: org.orgName, orgNumber: org.orgNumber }} />
      </div>
    </>
  );
}
